<p>
  photo-management works!
</p>
